export function formatAddress(
  addresses: {
    line1: string | null;
    line2: string | null;
    city: string | null;
    state: string | null;
    postalCode: string | null;
  }[],
): string {
  const primary = addresses.at(0);
  if (!primary) {
    return '—';
  }

  return [primary.line1, primary.line2, primary.city, primary.state, primary.postalCode]
    .filter(Boolean)
    .join(', ');
}

export function formatDateTime(value: number | null | undefined): string {
  return value && value > 0 ? new Date(value).toLocaleString() : '—';
}

export function maxRolledUpAtMs(values: Record<string, string | number> | null | undefined): number | null {
  if (!values) {
    return null;
  }

  const candidates = Object.values(values)
    .map((value) => (typeof value === 'number' ? value : Number(value)))
    .filter((value) => Number.isFinite(value));

  return candidates.length > 0 ? Math.max(...candidates) : null;
}
